/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {AngularModalService} from '../common/modal/angular-modal.service';
import {
  ReportScheduleRecipientsModalComponent,
  ReportScheduleRecipientsModalResult
} from './report-schedule-recipients-modal.component';

export interface ReportScheduleRecipientsModalOptions {
  recipientUsers: any[];
  isNew: boolean;
  scheduleModel?: any;
  salespersonId?: string;
  adOpsId?: string;
}

@Injectable({providedIn: 'root'})
export class ReportScheduleModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  openRecipientsModal(
    options: ReportScheduleRecipientsModalOptions,
    onClosed?: (result?: ReportScheduleRecipientsModalResult) => void
  ): void {
    const modalRef = this.angularModalService.show(ReportScheduleRecipientsModalComponent, {
      class: 'modal-lg',
      initialState: {
        recipientUsers: options.recipientUsers || [],
        isNew: options.isNew,
        scheduleModel: options.scheduleModel,
        salespersonId: options.salespersonId,
        adOpsId: options.adOpsId
      }
    });

    const modalContent = modalRef.content as ReportScheduleRecipientsModalComponent;
    modalContent.onClosed.subscribe((result) => {
      onClosed?.(result || undefined);
    });
  }
}
